module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/70LHLECLkndv2Mgfknli30-dccd61db6d948927c0b26476874dbc85.jpg";